export const ICON_LAYER = {
  OUTLINE: 'A',
  BASE: 'B',
  HOVERED: 'C',
  SELECTED: 'D',
  SHADOW: 'E',
};

export default {
  '1A': {
    x: 784,
    y: 988,
    width: 56,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '1B': {
    x: 752,
    y: 1140,
    width: 56,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '1C': {
    x: 752,
    y: 1064,
    width: 56,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '1D': {
    x: 808,
    y: 1140,
    width: 56,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '1E': {
    x: 848,
    y: 1216,
    width: 56,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: false,
  },
  '2A': {
    x: 960,
    y: 0,
    width: 64,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '2B': {
    x: 624,
    y: 684,
    width: 64,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '2C': {
    x: 960,
    y: 836,
    width: 64,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '2D': {
    x: 960,
    y: 912,
    width: 64,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '2E': {
    x: 784,
    y: 912,
    width: 64,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: false,
  },
  '3A': {
    x: 944,
    y: 76,
    width: 80,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '3B': {
    x: 944,
    y: 988,
    width: 80,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '3C': {
    x: 944,
    y: 1064,
    width: 80,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '3D': {
    x: 672,
    y: 1140,
    width: 80,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '3E': {
    x: 672,
    y: 1064,
    width: 80,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: false,
  },
  '4A': {
    x: 752,
    y: 836,
    width: 96,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '4B': {
    x: 688,
    y: 912,
    width: 96,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '4C': {
    x: 848,
    y: 988,
    width: 96,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '4D': {
    x: 688,
    y: 988,
    width: 96,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '4E': {
    x: 848,
    y: 1064,
    width: 96,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: false,
  },
  '5A': {
    x: 912,
    y: 152,
    width: 112,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '5B': {
    x: 624,
    y: 760,
    width: 112,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '5C': {
    x: 736,
    y: 760,
    width: 112,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '5D': {
    x: 848,
    y: 836,
    width: 112,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '5E': {
    x: 848,
    y: 912,
    width: 112,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: false,
  },
  '6A': {
    x: 368,
    y: 456,
    width: 128,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '6B': {
    x: 496,
    y: 836,
    width: 128,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '6C': {
    x: 496,
    y: 684,
    width: 128,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '6D': {
    x: 496,
    y: 760,
    width: 128,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '6E': {
    x: 624,
    y: 836,
    width: 128,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: false,
  },
  '7A': {
    x: 880,
    y: 228,
    width: 144,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '7B': {
    x: 352,
    y: 532,
    width: 144,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '7C': {
    x: 352,
    y: 608,
    width: 144,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '7D': {
    x: 352,
    y: 760,
    width: 144,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '7E': {
    x: 352,
    y: 684,
    width: 144,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: false,
  },
  '8A': {
    x: 864,
    y: 304,
    width: 160,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '8B': {
    x: 688,
    y: 456,
    width: 160,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '8C': {
    x: 688,
    y: 532,
    width: 160,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '8D': {
    x: 688,
    y: 608,
    width: 160,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '8E': {
    x: 688,
    y: 684,
    width: 160,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: false,
  },
  '9A': {
    x: 848,
    y: 456,
    width: 176,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '9B': {
    x: 848,
    y: 532,
    width: 176,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '9C': {
    x: 848,
    y: 608,
    width: 176,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '9D': {
    x: 848,
    y: 684,
    width: 176,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '9E': {
    x: 848,
    y: 760,
    width: 176,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: false,
  },
  '10A': {
    x: 464,
    y: 1220,
    width: 192,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '10B': {
    x: 656,
    y: 1220,
    width: 192,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '10C': {
    x: 496,
    y: 456,
    width: 192,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '10D': {
    x: 496,
    y: 532,
    width: 192,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '10E': {
    x: 496,
    y: 608,
    width: 192,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: false,
  },
  '11A': {
    x: 816,
    y: 380,
    width: 208,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '11B': {
    x: 464,
    y: 1068,
    width: 208,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '11C': {
    x: 480,
    y: 912,
    width: 208,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '11D': {
    x: 480,
    y: 988,
    width: 208,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '11E': {
    x: 464,
    y: 1144,
    width: 208,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: false,
  },
  '12A': {
    x: 256,
    y: 916,
    width: 224,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '12B': {
    x: 272,
    y: 836,
    width: 224,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '12C': {
    x: 240,
    y: 1068,
    width: 224,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '12D': {
    x: 240,
    y: 1144,
    width: 224,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '12E': {
    x: 240,
    y: 1220,
    width: 224,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: false,
  },
  '13A': {
    x: 0,
    y: 992,
    width: 240,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '13B': {
    x: 0,
    y: 1068,
    width: 240,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '13C': {
    x: 0,
    y: 1144,
    width: 240,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '13D': {
    x: 0,
    y: 1220,
    width: 240,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '13E': {
    x: 240,
    y: 992,
    width: 240,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: false,
  },
  '14A': {
    x: 96,
    y: 532,
    width: 256,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '14B': {
    x: 96,
    y: 608,
    width: 256,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '14C': {
    x: 96,
    y: 684,
    width: 256,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '14D': {
    x: 96,
    y: 760,
    width: 256,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '14E': {
    x: 0,
    y: 916,
    width: 256,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: false,
  },
  '15A': {
    x: 0,
    y: 380,
    width: 272,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '15B': {
    x: 272,
    y: 380,
    width: 272,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '15C': {
    x: 544,
    y: 380,
    width: 272,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '15D': {
    x: 0,
    y: 840,
    width: 272,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '15E': {
    x: 96,
    y: 456,
    width: 272,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: false,
  },
  '16A': {
    x: 304,
    y: 228,
    width: 288,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '16B': {
    x: 592,
    y: 228,
    width: 288,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '16C': {
    x: 0,
    y: 304,
    width: 288,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '16D': {
    x: 288,
    y: 304,
    width: 288,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '16E': {
    x: 576,
    y: 304,
    width: 288,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: false,
  },
  '17A': {
    x: 640,
    y: 76,
    width: 304,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '17B': {
    x: 0,
    y: 152,
    width: 304,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '17C': {
    x: 304,
    y: 152,
    width: 304,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '17D': {
    x: 608,
    y: 152,
    width: 304,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '17E': {
    x: 0,
    y: 228,
    width: 304,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: false,
  },
  '18A': {
    x: 0,
    y: 0,
    width: 320,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '18B': {
    x: 320,
    y: 0,
    width: 320,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '18C': {
    x: 640,
    y: 0,
    width: 320,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '18D': {
    x: 0,
    y: 76,
    width: 320,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: true,
  },
  '18E': {
    x: 320,
    y: 76,
    width: 320,
    height: 76,
    pixelRatio: '1',
    anchorY: 68,
    mask: false,
  },
  done: {
    x: 0,
    y: 456,
    width: 96,
    height: 96,
    pixelRatio: '1',
    anchorY: 48,
    mask: true,
  },
  departed: {
    x: 0,
    y: 456,
    width: 96,
    height: 96,
    pixelRatio: '1',
    anchorY: 48,
    mask: true,
  },
  leaving_start_location: {
    x: 0,
    y: 552,
    width: 96,
    height: 96,
    pixelRatio: '1',
    anchorY: 48,
    mask: true,
  },
  reaching_end_location: {
    x: 0,
    y: 648,
    width: 96,
    height: 96,
    pixelRatio: '1',
    anchorY: 48,
    mask: true,
  },
  skipped: {
    x: 0,
    y: 744,
    width: 96,
    height: 96,
    pixelRatio: '1',
    anchorY: 48,
    mask: true,
  },
};
